import { connect } from "react-redux";
import { getAllCSS, editCSS } from './actions';
import { Superadmin } from "./Superadmin";
import { navigatePath } from "../nav/actions";

function mapDispatchToProps(dispatch) {
  return({
    navigatePath: (path, args) => { dispatch(navigatePath(path, args))},
    getAllCSS: () => {dispatch(getAllCSS())},
    editCSS: (isEditing, selectedWlf) => {dispatch(editCSS(isEditing, selectedWlf))},
  })
}

function mapStateToProps(state) {
  return {
    user: state.user,
    token: state.user.token,
    userType: state.userType,
    client: state.client,
    isEditingCSS: state.cssDashboard.isEditingCSS,
    selectedWlf: state.cssDashboard.selectedWlf,
    allCSS: state.cssDashboard.allCSS,
    isFetching: state.cssDashboard.isFetching,
    error: state.cssDashboard.error,
    wlfs: state.wlfs,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Superadmin)